<template lang="pug">
    .z-task-checklist(v-bind:class="")
        .z-checklist__add-btn(v-on:click="addItem")
            span {{$props.label}}
            md-icon.small add
        .z-task-checklist-container(v-if="val && val.length")
            .z-checklist(v-for="(list, i) in val" v-bind:key="i")
                .z-checklist__head.z-hover
                    input.z-checklist__flat-input(v-model="list.l" placeholder="Заголовок чеклиста...")
                    md-button.md-icon-button.md-dense.close.small.z-task-checklist__add-btn(v-on:click="removeItem(i)"): md-icon delete
                .z-checklist__progress(v-if="percent[i] != undefined")
                    .z-checklist__progress__value {{Math.round(percent[i]) + '%'}}
                    .z-checklist__progress__container
                        .z-checklist__progress-line(v-bind:class="{'complete': parseInt(percent[i]) >= 100}" v-bind:style="'width: ' + percent[i] + '%;'")

                .z-checklist__body(v-if="list['i'] && list['i'].length")
                    .z-checklist__container
                        .z-checklist__check.z-hover(v-for="(check, j) in list['i']" v-bind:key="j" v-bind:class="{'complete': check.c}")
                            .z-checklist__checkbox(v-bind:class="{'checked': check.c}")
                                label(v-bind:for="('check-' + i + '-' + j)")
                                input(type="checkbox" v-model="check.c" v-bind:id="('check-' + i + '-' + j)")
                            input.z-checklist__flat-input(v-bind:ref="('check-input-' + i + '-' + j)" v-show="check.a || !check.l" v-model="check.l" placeholder="Чек" v-on:blur="disactivate(i, j)" v-on:focus="activate(i, j)")
                            .z-checklist__value(v-show="!check.a && check.l" v-on:click="focusCheck(('check-input-' + i + '-' + j), i, j)" v-bind:class="{'complete': check.c}") {{check.l}}

                            md-button.md-icon-button.md-dense.close.small.z-task-checklist__add-btn(v-on:click="removeCheck(i, j)"): md-icon delete
                .z-checklist__footer
                   .z-checklist__add-btn(v-on:click="addCheck(i)")
                        span Добавить чек
                        md-icon.small add
</template>
<script>
    export default {
        name: 'z-task-checklist',
        components: {},
        props: {
            id: {
                type: String,
                default: 'z-task-checklist'
            },
            name: {
                type: String,
                default: 'z-task-checklist'
            },
            label: {
                type: String,
                default: ''
            },
            value: {
                type: Array,
                default: () => []
            },
        },
        data() {
            return {
                val: [],
                checkStruct: {
                    l: null,   //label
                    c: false //complete
                },
                ItemStruct: {
                    l: null,    //label
                    c: false, //complete
                    i: []     //items of checks
                }
            }
        },
        created() {
            if (this.$props.value) this.val = Object.assign([], this.$props.value);
        },
        watch: {
            'value': {
                deep: true,
                handler(value) {
                    if (JSON.stringify(this.val) != JSON.stringify(value)) this.val = Object.assign([], value);
                }
            },
            'val'(val) {
                this.$emit('input', val);
                this.$emit('change', val);
            }
        },
        computed: {
            percent() {
                let result = {};
                if (!this.val || !this.val.length) return result;
                this.val.map((item, i) => {
                    if (!item.i || !item.i.length) result[i] = 0;
                    else {
                        let count = 0;
                        item.i.map(check => {
                            if (check.c) count++;
                        });
                        result[i] =  ((count * 100) / item.i.length);
                    }
                });
                return result;
            }
        },
        methods: {
            addItem() {
                let newList = Object.assign({}, {l: null, c: false, i: []});
                newList.l = 'Чек-лист ' + (this.val.length + 1);
                this.val.push(newList);
            },
            removeItem(i) {
                this.val.splice(i, 1);
            },
            focusCheck(ref, i, j) {
                this.activate(i, j);
                this.$nextTick(() => {
                    if (this.$refs[ref] instanceof Array) this.$refs[ref][0].focus();
                    else this.$refs[ref].focus();
                });
            },
            activate(i, j) {
                this.val[i]['i'][j]['a'] = true;
            },
            disactivate(i, j) {
                this.val[i]['i'][j]['a'] = false;
            },
            addCheck(i) {
                this.val[i]['i'].push({l: null, c: false, a: true});
            },
            removeCheck(i, j) {
                this.val[i]['i'].splice(j, 1);
            }
        }
    }
</script>
<style lang="sass">
    .z-task-checklist
        display: flex
        flex-direction: column
        align-items: flex-start
        justify-content: flex-start
        margin: 4px 0 10px 0
        .z-checklist__add-btn
            display: flex
            align-items: center
            justify-content: center
            font-size: 12px
            cursor: pointer
            transition: 0.1s
            height: 26px
            border-radius: 3px
            padding: 0 0px 0 6px
            .md-icon
                margin: 0 0 0 4px
        .z-checklist__add-btn:hover
            background: #e4e4e4
        .z-task-checklist__head
            display: flex
            align-items: center
            justify-content: flex-start
        label
            display: block
            color: rgba(0, 0, 0, 0.54)
            font-size: 12px
            line-height: 14px
            margin: 0 2px 0 0
        .z-task-checklist-container
            width: 100%
        .z-checklist
            margin: 0 0 20px 0
            .z-hover
                padding: 4px 6px
                border-radius: 3px
                .md-button
                    opacity: 0
            .z-hover:hover
                background: #eee
                .md-button
                    opacity: 1
            .z-checklist__head
                display: flex
                align-items: center
                justify-content: space-between
                margin: 0 0 4px 0
                .md-button
                    margin: 0 0 0 6px
            .z-checklist__progress
                display: flex
                align-items: center
                justify-content: flex-start
                font-size: 12px
                line-height: 12px
                padding: 0 0 0 6px
                margin: 0 0 4px 0
                .z-checklist__progress__value
                    margin: 0 5px 0 0
                    width: 30px
                .z-checklist__progress__container
                    width: 100%
                    height: 8px
                    width: 100%
                    background: rgba(9,30,66,.08)
                    border-radius: 4px
                    .z-checklist__progress-line
                        background: #448aff
                        height: 8px
                        border-radius: 4px
                        transition: 0.2s
                    .z-checklist__progress-line.complete
                        background: #61bd4f
            .z-checklist__body
                .z-checklist__container
                .z-checklist__check
                    display: flex
                    align-items: center
                    justify-content: flex-start
                    .z-checklist__checkbox
                        input
                            display: none
                        label
                            position: relative
                            display: block
                            width: 17px
                            height: 17px
                            background: transparent
                            border: 2px solid rgba(0,0,0,.54)
                            border-radius: 2px
                            overflow: hidden
                            margin: 0 5px 0 0
                            &:after
                                content: ''
                                position: absolute
                                display: block
                                width: 5px
                                height: 10px
                                border: 2px solid transparent
                                border-top: 0
                                border-left: 0
                                transform: rotate(45deg) scale3D(1,1,1)
                                transition: .4s cubic-bezier(.25,.8,.25,1)
                                left: 4px
                                top: 0
                        &.checked
                            label
                                background: #448aff
                                border-color: #448aff
                                &:after
                                    border-color: #fff
                    .md-button
                        opacity: 0
                    .z-checklist__value
                        width: 100%
                        padding: 4px 6px 4px 0
                        font-size: 14px
                        line-height: 16px
                        border: 1px solid transparent
                        box-sizing: border-box
                        font-weight: normal
                    .z-checklist__value.complete
                        text-decoration: line-through
                .z-checklist__check:hover
                    .md-button
                        opacity: 1
            .z-checklist__footer
                display: flex
                align-items: center
                justify-content: flex-start
            .z-checklist__flat-input
                font-size: 14px
                line-height: 16px
                width: 100%
                outline: none
                padding: 0 4px 0 0
                border-radius: 3px
                border: 1px solid transparent
                box-sizing: border-box
                transition: 0.2s
                background: transparent
                font-weight: normal
                height: 26px
                resize: none
                &:focus
                    background: #e0e0e0
                    border-color: #d4d4d4
                    background: #fff
                    border-color: #d4d4d4
                    padding: 0 4px
                    
                    
</style>


// WEBPACK FOOTER //
// ZTaskChecklist.vue?71f533ae